"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProjectCollaborators = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_project_collaborators_query_1 = require("./get-project-collaborators.query");
const mapCollaboratorOptions = (data) => {
    var _a, _b, _c, _d, _e;
    const collaborators = ((_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.projects) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.collaborators) === null || _e === void 0 ? void 0 : _e.edges) || [];
    return collaborators.map(({ node }) => ({
        id: node.id,
        label: node.name,
        value: node.name,
    }));
};
const useGetProjectCollaborators = ({ projectId }) => {
    const [isLoadRequested, setIsLoadRequested] = (0, react_1.useState)(false);
    const [fetchCollaborators, { called, loading: isLoading, data }] = (0, react_2.useLazyQuery)(get_project_collaborators_query_1.GET_PROJECT_COLLABORATORS, {
        fetchPolicy: 'cache-first',
    });
    const collaboratorOptions = (0, react_1.useMemo)(() => mapCollaboratorOptions(data), [data]);
    const loadCollaboratorOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!projectId) {
            return [];
        }
        setIsLoadRequested(true);
        try {
            const { data: fetchData } = yield fetchCollaborators({
                variables: { ids: [projectId] },
            });
            return mapCollaboratorOptions(fetchData);
        }
        finally {
            setIsLoadRequested(false);
        }
    }), [fetchCollaborators, projectId]);
    return {
        collaboratorOptions,
        loadCollaboratorOptions,
        isLoading,
        hasRequestedCollaborators: called || isLoadRequested,
    };
};
exports.useGetProjectCollaborators = useGetProjectCollaborators;
